import React from "react";
import PropTypes from "prop-types";

const AVATAR_COLORS = ["#4f46e5", "#34c38f", "#f1b44c", "#50a5f1", "#f46a6a", "#74788d"];

function getAvatarSeed(name, email) {
  return (name || email || "U").trim();
}

function getAvatarInitial(name, email) {
  const seed = getAvatarSeed(name, email);
  const firstAlphaNumeric = seed.match(/[A-Za-z0-9]/);
  return (firstAlphaNumeric?.[0] || "U").toUpperCase();
}

function getAvatarColor(name, email) {
  const seed = getAvatarSeed(name, email);
  const total = seed.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
  return AVATAR_COLORS[total % AVATAR_COLORS.length];
}

const UserAvatar = ({ photoURL, name, email, className = "", alt = "User avatar", style = {} }) => {
  if (photoURL) {
    return <img className={className} src={photoURL} alt={alt} style={style} />;
  }

  const backgroundColor = getAvatarColor(name, email);
  const initial = getAvatarInitial(name, email);

  return (
    <span
      className={className}
      aria-label={alt}
      role="img"
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        color: "#fff",
        backgroundColor,
        textTransform: "uppercase",
        ...style,
      }}
    >
      {initial}
    </span>
  );
};

UserAvatar.propTypes = {
  photoURL: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  style: PropTypes.object,
};

export default UserAvatar;